var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTwitter2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e9ee60"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3bafca"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-128 -7287)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(19 2569)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(109 4718)",
    fill: "none",
    stroke: "#dae028",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 25,
    r: 25,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 25,
    r: 23.5,
    fill: "none"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(136 7299)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M181.9,61.051l3.6-.707a33.465,33.465,0,0,1-3.6,3.537h0a13.98,13.98,0,0,0,0,2.122c-6.912,29.143-32.4,16.269-32.4,16.269,9.288.212,10.08-3.537,10.08-3.537-5.4-.778-6.48-4.244-6.48-4.244a2.243,2.243,0,0,0,2.88-.707,6.415,6.415,0,0,1-5.04-7.074,7.567,7.567,0,0,0,3.528,1.344c-.648-.778-6.12-7.215-2.808-10.54,0,0,4.032,7.073,14.616,7.71l.72-.141a5.456,5.456,0,0,1-.144-1.556,7.494,7.494,0,0,1,7.56-7.427c5.04,0,6.12,2.829,6.12,2.829l3.6-2.122C184.06,56.807,183.7,60.344,181.9,61.051Z",
    transform: "translate(-149.5 -56.1)",
    fill: "url(#a)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter2);
export default __webpack_public_path__ + "static/media/Twitter_2.3d11c4005b1b852f39a3282778570a9a.svg";
export { ForwardRef as ReactComponent };